import { Link } from "react-router-dom";
import notFoundImg from "../images/page_not_found.svg";

const NotFound = () => {
  return (
    <div className="d-flex vh-100 justify-content-center align-items-center">
      <div className="text-center">
        <div style={{ height: "auto", width: "300px" }} className="mb-5">
          <img src={notFoundImg} alt="No route match" className="img-fluid " />
        </div>
        <Link
          to="/"
          className="bg-american-yellow inline-block py-3 rounded-3 mt-5 px-5 border-0 text-white gilroy-bold fs-20 text-decoration-none"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
